var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 4,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dots-line_svg__clip0_1139_56315)",
    fill: "#E2E5F1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.5,
    cy: 2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 2,
    r: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dots-line_svg__clip0_1139_56315"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h227v3H0z"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgDotsLine as ReactComponent };